import { Icon, Sheet, Text } from '@/ui'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { AddTransaction } from '../Upload/AddTransaction'
import { TransactionTypes } from '@/features/transactions/constants'
import { UploadSuccessPayload } from './Module'
import { TypographyStyles } from '@/styles'

export const UploadTransactionSheet = ({
  sheetOpen,
  closeSheet,
  sheetType,
  sheetIcon,
  onUploadComplete,
}: {
  sheetOpen: boolean
  closeSheet: () => void
  sheetType: TransactionTypes
  sheetIcon: IconProp | null
  onUploadComplete: (_args: {
    success: boolean
    data?: UploadSuccessPayload[]
  }) => void
}) => {
  return (
    <Sheet open={sheetOpen} onOpenChange={(val) => !val && closeSheet()}>
      <Sheet.Content side="right" className="w-full sm:max-w-md">
        <Sheet.Title>
          <div className="flex flex-row items-center mb-4">
            {sheetIcon && (
              <Icon
                icon={sheetIcon}
                color="text-neutral-0"
                className="mr-4 bg-neutral-700 rounded-md p-2"
              />
            )}
            <Text variant={TypographyStyles.H2}>Add {sheetType}</Text>
          </div>
        </Sheet.Title>
        {sheetType && (
          <AddTransaction
            transactionType={sheetType}
            closeFlyout={closeSheet}
            onUploadComplete={onUploadComplete}
          />
        )}
      </Sheet.Content>
    </Sheet>
  )
}
